import { Injectable, inject } from '@angular/core';
import {
	ApplicationInsights,
	DistributedTracingModes
} from '@microsoft/applicationinsights-web';
import { IdentityService } from '../identity/identity.service';

@Injectable()
export class LoggingService {
	identity = inject(IdentityService);

	appInsights: ApplicationInsights;

	constructor() {
		this.appInsights = new ApplicationInsights({
			config: {
				//instrumentationKey: environment.instrumentationKey,
				connectionString:
					'InstrumentationKey=d563deb2-22c9-4795-a5b1-f54386622863;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/', // provided by Azure
				distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
				enableCorsCorrelation: true,
				disableFetchTracking: false,
				disableAjaxTracking: false,
				disableCorrelationHeaders: false,
				enableAutoRouteTracking: true // option to log all route changes
			}
		});
		this.appInsights.loadAppInsights();
		this.appInsights.addTelemetryInitializer((envelope) => {
			const item = envelope.baseData;
			item.properties = item.properties || {};
			item.properties['ApplicationPlatform'] = 'Web';
			item.properties['ApplicationName'] = 'portal.lyrawellbeing.health';
			envelope.tags['ai.cloud.role'] = 'portal.lyrawellbeing.health';
		});
		this.identity.userData$.subscribe((user) => {
			if (!user) {
				this.appInsights.clearAuthenticatedUserContext();
				return;
			}
			this.appInsights.setAuthenticatedUserContext(
				user.name,
				user.sub,
				true
			);
		});
		this.appInsights.trackPageView();
	}

	logPageView(name?: string, url?: string) {
		// option to call manually
		this.appInsights.trackPageView({
			name: name,
			uri: url
		});
	}

	logEvent(name: string, properties?: { [key: string]: any }) {
		this.appInsights.trackEvent({ name: name }, properties);
	}

	startTrack(name: string) {
		this.appInsights.startTrackEvent(name);
	}

	stopTrack(name: string, properties?: { [key: string]: any }) {
		this.appInsights.stopTrackEvent(name, properties);
	}

	logMetric(
		name: string,
		average: number,
		properties?: { [key: string]: any }
	) {
		this.appInsights.trackMetric(
			{ name: name, average: average },
			properties
		);
	}

	logException(exception: Error, severityLevel?: number) {
		console.error(exception);
		this.appInsights.trackException({
			exception: exception,
			severityLevel: severityLevel
		});
	}

	logTrace(message: string, properties?: { [key: string]: any }) {
		this.appInsights.trackTrace({ message: message }, properties);
	}
}
